import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DisplayQualifiedWorkingTimeCheckboxComponent } from '../timeline-filters/display-qualified-working-time-checkbox/display-qualified-working-time-checkbox.component';
import { ShowQualifedStaffCheckboxComponent } from '../timeline-filters/show-qualifed-staff-checkbox/show-qualifed-staff-checkbox.component';
import { UserShiftAssignmentAvailabilityFilterComponent } from '../timeline-filters/user-shift-assignment-availability-filter/user-shift-assignment-availability-filter.component';

@Component({
  selector: 'wilson-grouped-shift-staff-status-filter',
  imports: [
    TranslateModule,
    ShowQualifedStaffCheckboxComponent,
    DisplayQualifiedWorkingTimeCheckboxComponent,
    UserShiftAssignmentAvailabilityFilterComponent,
  ],
  templateUrl: './grouped-shift-staff-status-filter.component.html',
  styleUrls: ['./grouped-shift-staff-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupedShiftStaffStatusFilterComponent {}
